<!-- 地址管理 -->
<template>
  <div class="content-box" id="address-manage">
    <!-- header start -->
    <van-nav-bar
      title="地址管理"
      fixed
      :placeholder="true"
      :z-index="99"
      left-arrow
      @click-left="goBack"
    />
    <!-- header end -->

    <div class="bodys">
      <div class="noAddress" v-if="addressList.length <= 0">
        <img src="~@/assets/images/NOaddress.png" alt="" />
        <div>暂无地址哦~</div>
      </div>
      <div class="address-list" v-if="addressList.length > 0">
        <van-radio-group v-model="radio">
          <div
            class="every-address"
            v-for="(item, index) in addressList"
            :key="index"
          >
            <div
              @click="selectAddress(item.SerialNumber)"
              class="every-address-top"
            >
              <div class="every-address-top-name">
                {{ item.Name }}<span>{{ item.Phone }}</span>
              </div>
              <div class="every-address-top-address">
                {{ item.AreaNames }}{{ item.Address }}
              </div>
            </div>
            <div class="every-address-bottom">
              <div
                class="every-address-bottom-left"
                v-if="item.IsDefault"
                tapmode
              >
                <van-icon name="location-o" color="red" />
                <span style="color:red">默认</span>
                <!-- <van-radio
                  v-if="item.isDefault==true"
                  :name="1"
                  checked-color="#FF669E"
                  icon-size="18"
                  >默认地址</van-radio>
                <van-radio
                  v-else
                  :name="0"
                  checked-color="#FF669E"
                  icon-size="18"
                  >默认地址</van-radio> -->
              </div>
              <div class="every-address-bottom-left" v-else tapmode></div>
              <div class="every-address-bottom-right">
                <div @click="editAddress(item)">
                  <img src="~@/assets/images/edit.png" alt="" />修改
                </div>
                <div @click="deleteAddress(item.SerialNumber)">
                  <img src="~@/assets/images/delete.png" alt="" />删除
                </div>
              </div>
            </div>
          </div>
        </van-radio-group>
      </div>
      <div class="add-address" @click="addAddress(1)" tapmode>增加新地址</div>
    </div>
  </div>
</template>

<script>
import { Toast, Dialog } from "vant";

export default {
  data() {
    return {
      addressList: [],
      radio: 1,
    };
  },
  created() {
    this.getAddressList();
  },
  methods: {
    goBack() {
      this.goNotData();
    },
    goNotData() {
      if (this.$route.meta.isBack) {
        if (this.addressList.length == 1) {
          var _address = this.addressList[0];
          this.$store.commit({
            type: "setMemberAddress",
            data: _address,
          });
          this.$router.go(-1);
        } else {
          this.$router.go(-1);
        }
      } else {
        this.$router.go(-1);
      }
    },
    selectAddress(id) {
      if (this.$route.meta.isBack) {
        var _address = this.addressList.filter((x) => x.SerialNumber == id)[0];
        this.$store.commit({
          type: "setMemberAddress",
          data: _address,
        });
        this.$router.go(-1);
      }
    },
    addAddress(id) {
      this.$router.push({ name: "AddressAdd" });
    },
    editAddress(model) {
      this.$router.push({ name: "AddressEdit", params: { model: model } });
    },
    deleteAddress(id) {
      //console.log(id,"deleteAddress");
      var _this = this;
      Dialog.confirm({
        // title: "提示",
        message: "确定删除吗？"
      })
        .then(() => {
          _this.$store
            .dispatch({ type: "deleteMemberAddress", id: id })
            .then((res) => {
              Toast(res.Result.Message);
              var _addressList = [];
              for (let i = 0; i < _this.addressList.length; i++) {
                if (_this.addressList[i].SerialNumber != id) {
                  _addressList.push(_this.addressList[i]);
                }
              }
              _this.addressList = _addressList;
            });
        })
        .catch(() => {});
    },
    getAddressList() {
      var _this = this;
      this.$store.dispatch({ type: "getAddressList" }).then((res) => {
        //  console.log(res,"getAddressList");
        _this.addressList = res.Result.data;
      });
    },
    radioChange(id) {
      var _this = this;
      this.$store
        .dispatch({ type: "setMemberAddressDefalut", id: id })
        .then((res) => {
          if (res.result.status) {
            for (let i = 0; i < _this.addressList.length; i++) {
              if (_this.addressList[i].serialNumber == id) {
                _this.addressList[i].isDefault = false;
              } else {
                _this.addressList[i].isDefault = true;
              }
            }
            // this.$router.go(0);
            Toast(res.result.message);
          } else {
            this.$toast(res.result.message);
          }
        });
    },
  },
  beforeRouteEnter(to, from, next) {
    if (from.name == "User") {
      to.meta.isBack = false;
    } else {
      to.meta.isBack = true;
    }
    next();
  },
};
</script>
<style  scoped>
.bodys {
  width: 100%;
  height: auto;
  padding-bottom: 42px;
}

/*没有地址*/
.noAddress {
  width: 100%;
  height: auto;
  padding-top: 42px;
}

.noAddress img {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  display: block;
  margin: auto;
}

.noAddress div {
  width: 100%;
  height: auto;
  font-size: 13px;
  color: #999;
  text-align: center;
  margin-top: 21px;
}

/*设置*/

.address-list {
  width: 100%;
  height: auto;
  margin-top: 7.98px;
}

.every-address {
  width: 100%;
  height: auto;
  background-color: #fff;
  padding: 0px 13px;
  margin-bottom: 7.98px;
}

.every-address-top {
  width: 100%;
  height: auto;
  padding: 18px 0px;
  border-bottom: 1px solid #f2f2f2;
}

.every-address-top-name {
  width: 100%;
  font-size: 17px;
  color: #333333;
}

.every-address-top-name span {
  margin-left: 9px;
}

.every-address-top-address {
  width: 100%;
  font-size: 15px;
  color: #666666;
  margin-top: 2px;
}

.every-address-bottom {
  width: 100%;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.every-address-bottom-left {
  display: flex;
  align-items: center;
}
.every-address-bottom-left .van-radio {
  font-size: 15px;
  color: #333333;
}

.every-address-bottom-right {
  display: flex;
  align-items: center;
}
.every-address-bottom-right > div {
  height: 42px;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #666666;
  margin-left: 21px;
}
.every-address-bottom-right > div > img {
  width: 15px;
  display: block;
  margin-right: 2px;
}

.add-address {
  width: 76%;
  height: 46px;
  margin: auto;
  margin-top: 52px;
  border: 1px solid #24a378;
  font-size: 17px;
  color: #24a378;
  text-align: center;
  line-height: 46px;
  border-radius: 90px;
}
</style>
